import Cookies from 'js-cookie';

import { getAccessToken } from './auth';

function zoom(scale) {
  const viewportMeta = document.getElementById('viewport-meta');
  (
    viewportMeta as any
  ).content = `initial-scale=${scale}, minimum-scale=${scale}, maximum-scale=${scale}`;
}

export function isFullSiteMode() {
  return Cookies.get('responsive_enabled') === 'false';
}

export function isMobileDevice() {
  return window.innerWidth <= 991;
}

export function setFullSiteMeta() {
  zoom(0.01);

  setTimeout(() => {
    const viewportMeta = document.getElementById('viewport-meta');
    (viewportMeta as any).content = 'width=1024';
  }, 500);
}

export function setMobileMeta() {
  zoom(1);

  setTimeout(() => {
    const viewportMeta = document.getElementById('viewport-meta');
    (viewportMeta as any).content = 'width=device-width';
  }, 500);
}

export function setResponsiveMode(responsive) {
  const expireTime = 365; // 1 year

  if (responsive) {
    // responsive === true
    Cookies.set('responsive_enabled', 'true', {
      path: '/',
      expires: expireTime,
    });
  } else {
    Cookies.set('responsive_enabled', 'false', {
      path: '/',
      expires: expireTime,
    });
  }
}

export function setDefaultResponsiveMode() {
  const accessToken = getAccessToken();

  if (isMobileDevice()) {
    // mobile screen
    // when user open backoffice at the first time, or user do logout, it should be in responsive mode
    if (!isFullSiteMode() || accessToken === undefined) {
      setResponsiveMode(true);
      // enable responsive
      setMobileMeta();
    } else {
      // disable responsive
      setFullSiteMeta();
      setResponsiveMode(false);
    }
  } else {
    // desktop screen
    // set default view and responsive mode in desktop
    setResponsiveMode(true);
    setMobileMeta();
  }
}
